export default {
  choose_existing: "Choose an existing autopilot or add a new one:",
  not_found: "The autopilot not found",
  create_new: "To create a new autopilot",
  department_tab: "go to the autopilot tab.",
  department: "autopilot",
  information: "Information",
  job_title: "Job title",
  application: "Software",
  applications_list: "All software",
  no_app_selected: "No software selected",
  security: "Security",
  configuration: "Configuration",
  security_profiles: "Security",
  configuration_profiles: "Configuration",
  department_details: "Autopilot details",
  manager: "Manager",
  department_name: "Autopilot name",
  employees: "Users",
  devices: "Devices",
  job_titles: "Job Titles",
  applications: "Software",
  delete_job_title: "Delete job title",
  you_can_NOT_delete: "You can NOT delete!",
  edit_department_info: "Edit autopilot info",
  no_departments: "No autopilot",
  employees_with_this_job_title: "Users with this job title",
  edit_job_title: "Edit job title",
  job_title_details: "Job title details",
  all_job_titles: "All job titles",
  add_job_titles: "Add job titles",
  add_job_title: "Add job title",
  search_Job_titles: "Search in job titles",
  edit_job_title_des:
    "Once changes are made, Trio automatically updates users’ job titles.",
  edit_department: "Edit autopilot",
  job_positions: "Job Positions",
  search_departments: "Search in autopilot",
  departments_list: "autopilot",
  create_department: "Add Autopilot",
  departments_list_contentSubTitle:
    "autopilot allow you to organize devices and users, such as those in Tech or HR, enabling streamlined assignment, management, and policy enforcement.",
  delete_the_department: "Delete Autopilot?",
  deleting_department_all_assets:
    "If you delete a autopilot, everything assigned to that autopilot will become unassigned.",
  no_departments_des:
    "Upon assigning devices to users, they will be also assigned to the respective autopilot.",
  delete_department: "Delete autopilot",
  remove_from_department: "Unassign from autopilot",
  edit: "Edit",
  MACOS: "Mac",
  IOS: "iPhone",
  IPADOS: "iPad",
  ANDROID: "Android",
  WINDOWS: "Windows",
  TRIOPROFILE: "Suggested Profiles",
  add_MACOS_profiles: "Add Mac Profiles",
  add_IOS_profiles: "Add iPhone Profiles",
  add_IPADOS_profiles: "Add iPad Profiles",
  add_TRIOPROFILE_profiles: "Add Trio Profiles",
  add_ANDROID_profiles: "Add Android Profiles",
  add_WINDOWS_profiles: "Add Windows Profiles",
  MACOS_security_profiles: "Mac Security",
  WINDOWS_security_profiles: "Windows Security",
  IOS_security_profiles: "iPhone Security",
  ANDROID_security_profiles: "Android Security",
  IPADOS_security_profiles: "iPad Security",
  MACOS_configuration_profile: "Mac Configuration",
  WINDOWS_configuration_profile: "Windows Configuration",
  IOS_configuration_profile: "iPhone Configuration",
  IPADOS_configuration_profile: "iPad Configuration",
  ANDROID_configuration_profile: "Android Configuration",
  search_profile: "Search in Profiles",
  choose_manager: "Choose a manager",
  create_job_titles: "Add job titles",
  not_set_yet: "Not set yet",
  assign_applications: "Assign software",
  select_applications_list: "Select from Software Library",
  select_security_profiles: "Select Security",
  select_configuration_profiles: "Select Configuration",
  operating_system_add_multiple_profiles:
    "You can add multiple profiles for each operating system.",
  skipped_wont_set_restrictions: "No profiles means no restrictions.",
  not_added_yet: "Not added yet",
  cancel_process: "Are you sure you want to cancel the process?",
  install_applications_department:
    "Select and install software for this Autopilot.",
  department_should_list_one_job_title:
    "Each Autopilot should have at least one job title.",
  department_description: "Description (Optional)",
  assignedemployeesjobposition:
    "All assigned users in this job position will be released",
  delete_dep_body_description:
    "You can’t delete autopilot that contain main assets, in this autopilot you have:",
  delete_dep_warning:
    "For deleting autopilot please remove assets from this autopilot or transfer assets to another one",
  enter_basic_information: "Enter basic information to create a Autopilot",
  assignApplicationToDepartment: "Assign software to Department",
  addSecurityProfile: "Add Security",
  addConfigurationProfile: "Add Configuration",
  enableLocationTrackingTitle:
    "Enable/Disable location tracking for this autopilot ",
  enableLocationTrackingDescription: `You can specify that all the devices that are enrolled, their location tracking is turned on or off.`,
  delete_title: "Delete autopilot?",
  delete_description: "Do you want to delete the autopilot permanently?",
  delete_subDescription:
    "If you delete a autopilot,  all Software and Profiles assigned to it will be unassigned",
  delete_warning: "This action cannot be undone.",

  delete_cancel: "Cancel",
  delete_delete: "Delete",
  unable_delete_title: "Unable to delete!",
  unable_delete_description:
    "You can't delete autopilot that contain primary assets assigned to them",
  unable_main_assets: "Main Assets:",
  unable_delete_warning:
    "To delete a autopilot, remove all assets from it first",
  success_delete_title: "Autopilot deleted!",
  success_delete_description: "The autopilot has been successfully removed.",
  delete_job_description: "So you want to delete the Job title permanently?",
  delete_undone: "This action cannot be undone.",
  success_delete_job_title: "Job title deleted!",
  success_delete_job_title_description:
    "The job title has been deleted successfully.",
  createAutopilot: "Create Autopilot",
};
